import { EventType } from '../../../../domain/Calendar/CalendarEvent';
import { withEventSubmit } from '../../../common/EventForm/withEventSubmit';
import { NewStoreEventForm } from './NewStoreEventForm';
import { createEvent } from '../../../../api/calendar';

export default withEventSubmit(NewStoreEventForm, EventType.Store, createEvent);
